/*
 * Admin Settings tab: forward email, endpoint, subject, body, checkboxes, save.
 */

import React from "react";
import i18n from "../../../i18n/i18n.js";

export default function AdminSettingsTab({
  adminSettings,
  setAdminSettings,
  textareaRef,
  onSaveSettings,
  loading,
  getTextDirection,
}) {
  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
      <div className="px-4 py-3 border-b border-gray-200">
        <h3 className="text-sm font-semibold text-gray-900">
          {i18n.t("labels.organizationSettings")}
        </h3>
      </div>
      <div className="p-4 space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {i18n.t("labels.forwardEmailAddress")}
          </label>
          <input
            type="email"
            value={adminSettings.forwardEmail}
            onChange={(e) => setAdminSettings({ ...adminSettings, forwardEmail: e.target.value })}
            placeholder={i18n.t("placeholders.forwardEmail")}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {i18n.t("labels.endpointUrl")}
          </label>
          <input
            type="url"
            value={adminSettings.endpointUrl}
            readOnly
            placeholder={i18n.t("placeholders.endpointUrl")}
            className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100 cursor-not-allowed"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            {i18n.t("labels.addSubject")}
          </label>
          <input
            type="text"
            value={adminSettings.emailSubject}
            onChange={(e) => setAdminSettings({ ...adminSettings, emailSubject: e.target.value })}
            placeholder={i18n.t("placeholders.emailSubject")}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        <div>
          {/* <label className="block text-sm font-medium text-gray-700 mb-2">
            {i18n.t("labels.addEmailBody")}
          </label> */}

          <label className="flex items-center my-2">
            <input
              type="checkbox"
              checked={adminSettings.allowUserFeedback}
              onChange={(e) => {
                const checked = e.target.checked;
                setAdminSettings({
                  ...adminSettings,
                  allowUserFeedback: checked,
                  emailBody: checked ? adminSettings.emailBody : "",
                });
              }}
              className="rounded border-gray-300 accent-[#0C75D1] text-[#0C75D1] focus:ring-[#0C75D1]"
            />
            <span className="mx-2 text-sm text-gray-700">{i18n.t("labels.allowUserFeedback")}</span>
          </label>

          <textarea
            ref={textareaRef}
            placeholder={i18n.t("placeholders.emailBody")}
            name="emailBody"
            id="emailBody"
            value={adminSettings.emailBody}
            onChange={(e) => setAdminSettings({ ...adminSettings, emailBody: e.target.value })}
            disabled={!adminSettings.allowUserFeedback}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
          />
        </div>

        <div className="space-y-3">
          <h4 className="text-sm font-medium text-gray-700">{i18n.t("labels.enableActions")}</h4>

          <label className="flex items-start">
            <input
              type="checkbox"
              checked={adminSettings.allowMove}
              disabled={adminSettings.allowDelete}
              onChange={(e) =>
                setAdminSettings({
                  ...adminSettings,
                  allowMove: e.target.checked,
                  allowDelete: e.target.checked ? false : adminSettings.allowDelete,
                })
              }
              className="mt-1 rounded border-gray-300 accent-[#0C75D1] text-[#0C75D1] focus:ring-[#0C75D1] disabled:opacity-50"
            />
            <span className="mx-2 text-sm text-gray-700">
              {i18n.t("labels.allowMoveEmailToJunk")}
            </span>
          </label>

          <label className="flex items-center">
            <input
              type="checkbox"
              checked={adminSettings.allowDelete}
              disabled={adminSettings.allowMove}
              onChange={(e) =>
                setAdminSettings({
                  ...adminSettings,
                  allowDelete: e.target.checked,
                  allowMove: e.target.checked ? false : adminSettings.allowMove,
                })
              }
              className="rounded border-gray-300 accent-[#0C75D1] text-[#0C75D1] focus:ring-[#0C75D1] disabled:opacity-50"
            />
            <span className="mx-2 text-sm text-gray-700">{i18n.t("labels.allowDeleteEmail")}</span>
          </label>

          {/* <label className="flex items-center">
            <input
              type="checkbox"
              checked={adminSettings.allowUserFeedback}
              onChange={(e) =>
                setAdminSettings({ ...adminSettings, allowUserFeedback: e.target.checked })
              }
              className="rounded border-gray-300 accent-[#0C75D1] text-[#0C75D1] focus:ring-[#0C75D1]"
            />
            <span className="mx-2 text-sm text-gray-700">
              {i18n.t("labels.allowUserFeedback")}
            </span>
          </label> */}

          <label className="flex items-start">
            <input
              type="checkbox"
              checked={adminSettings.forwardPhishingToSoc}
              onChange={(e) =>
                setAdminSettings({ ...adminSettings, forwardPhishingToSoc: e.target.checked })
              }
              className="rounded border-gray-300 accent-[#0C75D1] text-[#0C75D1] focus:ring-[#0C75D1] mt-1"
            />
            <span className="mx-2 text-sm text-gray-700">
              {i18n.t("labels.forwardPhishingEmailsToSoc")}
            </span>
          </label>
        </div>

        <div className="flex gap-2">
          <button
            onClick={onSaveSettings}
            disabled={loading || !adminSettings.forwardEmail.trim()}
            className="flex-1 bg-[#46A2F2] text-white px-4 py-2 rounded-md hover:bg-[#0C75D1] focus:outline-none focus:ring-2 focus:ring-[#337ab7] focus:ring-offset-2 disabled:opacity-50 cursor-pointer disabled:cursor-not-allowed text-sm"
          >
            {loading ? i18n.t("common.saving") : i18n.t("labels.saveSettings")}
          </button>
        </div>
        {!adminSettings.forwardEmail.trim() && (
          <div className="text-sm text-red-600 mt-2">
            {i18n.t("messages.forwardEmailRequiredMessage")}
          </div>
        )}
      </div>
    </div>
  );
}
